import { Injectable } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { UserManagementUser } from 'app/models/user-management-user';
import License from 'app/models/license';
import { tap } from 'rxjs/operators';
import { UserUpdatedAction } from 'app/store/actions/user.actions';
import { DashNotificationsService } from './dash-notifications.service';
import { Store } from 'app/store/states/app.state';

@Injectable({
  providedIn: 'root'
})
export class LicenseService {

  constructor(
    private apiService: ApiService,
    private notifications: DashNotificationsService,
    private store: Store<any>
  ) {}

  create(user: UserManagementUser, license: License){
    return this.apiService.post<License>(`/users/${user.id}/licenses`, {
        state: license.state,
        number: license.number
      })
      .pipe(
        tap(
          () => this.notifications.success('License successfully created.'),
          (error: any) => this.notifications.error(error && error.message ? error.message : 'An error occurred and we weren\'t able to create the license')
        )
      )
  }

  update(user: UserManagementUser, license: License){
    return this.apiService.patch<License>(`/users/${user.id}/licenses/${license.id}`, {
      state: license.state,
      number: license.number
    })
    .pipe(
      tap(
        () => this.notifications.success('License successfully updated.'),
        (error: any) => this.notifications.error(error && error.message ? error.message : 'An error occurred and we weren\'t able to update the license')
      )
    )
  }

  delete(user: UserManagementUser, license: License){
    return this.apiService.delete<License[]>(`/users/${user.id}/licenses/${license.id}`)
      .pipe(
        tap(
          () => this.notifications.success('License successfully deleted.'),
          (error: any) => this.notifications.error(error && error.message ? error.message : 'An error occurred and we weren\'t able to delete the license')
        )
      )
  }
}
